import { Navigate } from "react-router-dom";

const DoctorProtectedRoute = ({ children }) => {
  const doctor = localStorage.getItem("doctor");

  if (!doctor) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default DoctorProtectedRoute;
